import ViewSalesDebitNote from "../../../../components/@documents/sales_debit_notes/ViewSalesDebitNote";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function SalesDebitNoteViewPage() {

    return (
        <ViewSalesDebitNote 
            routeType={routeTypes.admin}
        />
    )
}